<template>
  <section class="online-scheduling-seeb">
    <link
      href="http://fonts.googleapis.com/css?family=Lato:400,700"
      rel="stylesheet"
      type="text/css"
    />

    <div class="site-container site-section-v">
      <section class="online-scheduling-seeb">
        <div class="form-contact-content-scheduling-seeb">
          <form
            @submit.prevent="submit"
            style="width: 70%; margin: auto 15%"
            id="form-scheduling"
          >
            <slot name="form-top"></slot>
            <h2>Agendamento</h2>
            <p class="center">
             Se você preferir, marque um horário <br/>
             É só preencher os campos abaixo.
            </p>
            <field
              has-border
              is-small
              placeholder="Nome Completo"
              :input="{ type: 'text', name: 'Nome', required: 'required' }"
            />

            <field
              has-border
              is-small
              placeholder="E-mail"
              :input="{ type: 'email', name: 'Email', required: 'required' }"
            />

            <field
              has-border
              is-small
              placeholder="Telefone"
              :input="{ type: 'tel', name: 'Telefone', required: 'required' }"
            />

            <field
              has-border
              is-small
              placeholder="Possui algum processo com a Crivelli?"
              :input="{ name: 'ProcessoAtivo', required: 'required' }"
            >
              <template v-slot:default="{ changeFocus }">
                <select
                  @focus="changeFocus(true)"
                  v-model="ProcessoAtivo"
                  required
                  name="ProcessoAtivo"
                >
                  <option value="1">Sim</option>
                  <option value="0">Não</option>
                </select>
              </template>
            </field>

            <field
              has-border
              is-small
              placeholder="Qual o nome do banco?"
              :input="{ type: 'text', name: 'Banco', required: 'required' }"
            />

            <field
              has-border
              is-small
              placeholder="Você foi demitido deste banco?"
              :input="{ name: 'Demitido', required: 'required' }"
            >
              <template v-slot:default="{ changeFocus }">
                <select
                  @focus="changeFocus(true)"
                  v-model="Demitido"
                  required
                  name="Demitido"
                >
                  <option value="1">Sim</option>
                  <option value="0">Não</option>
                </select>
              </template>
            </field>

            <field
              has-border
              is-small
              placeholder="Você é sócio do sindicato?"
              :input="{ name: 'Sindicalizado', required: 'required' }"
            >
              <template v-slot:default="{ changeFocus }">
                <select
                  @focus="changeFocus(true)"
                  v-model="Sindicalizado"
                  required
                  name="Sindicalizado"
                >
                  <option value="1">Sim</option>
                  <option value="0">Não</option>
                </select>
              </template>
            </field>

            <field
              has-border
              is-small
              placeholder="Período de sindicalização?"
              :input="{ name: 'PeriodoSindicalizado', required: 'required' }"
            >
              <template v-slot:default="{ changeFocus }">
                <select
                  @focus="changeFocus(true)"
                  v-model="PeriodoSindicalizado"
                  required
                  name="PeriodoSindicalizado"
                >
                  <option value="0">Menos que 1 ano</option>
                  <option value="1">Entre 1 e 3 anos</option>
                  <option value="2">Mais que 3 anos</option>
                </select>
              </template>
            </field>

            <field
              has-border
              is-small
              placeholder="Selecionar Área desejada"
              :input="{ name: 'Area', required: 'required' }"
            >
              <template v-slot:default="{ changeFocus }">
                <select
                  required
                  v-model="Area"
                  @focus="changeFocus(true)"
                  name="Area"
                >
                  <option
                    v-for="(area, key) in areas"
                    :key="key"
                    :value="area.id"
                  >
                    {{ area.name }}
                  </option>
                </select>
              </template>
            </field>

            <field
              has-border
              is-small
              placeholder="Motivo do Agendamento"
              :input="{ name: 'MotivoAtendimento', required: 'required' }"
            >
              <template v-slot:default="{ changeFocus }">
                <textarea
                  name="MotivoAtendimento"
                  required
                  @blur="changeFocus(false)"
                  @focus="changeFocus(true)"
                ></textarea>
              </template>
            </field>

            <field
              has-border
              is-small
              placeholder="Data do Atendimento"
              :input="{ name: 'Data', required: 'required' }"
            >
              <template v-slot:default="{ changeFocus }">
                <select
                  required
                  v-model="Data"
                  name="data"
                  id="data"
                  class="form-control"
                  tabindex="12"
                  @focus="changeFocus(true)"
                  @change="getHours($event)"
                >
                  <option
                    v-for="(date, key) in datas"
                    :key="key"
                    :value="date.id"
                  >
                    {{ date.text }}
                  </option>
                </select>
              </template>
            </field>

            <field
              has-border
              is-small
              placeholder="Horário do Atendimento?"
              :input="{ name: 'Data', required: 'required' }"
            >
              <template v-slot:default="{ changeFocus }">
                <select
                  v-model="DataAtendimento"
                  name="DataAtendimento"
                  id="DataAtendimento"
                  class="form-control"
                  tabindex="12"
                  @focus="changeFocus(true)"
                  required
                >
                  <option
                    v-for="(hora, key) in horarios"
                    :key="key"
                    :value="hora.id"
                  >
                    {{ hora.text }}
                  </option>
                </select>
              </template>
            </field>

            <p class="text-center">
              <button type="submit" class="button" :disabled="buttonSubmited">
                ENVIAR
              </button>
            </p>
          </form>

          <div id="message-success" style="margin: 0; position: absolute; top: 50%; display: none">
            <h2>
              Agendamento realizado com sucesso!
            </h2>
            <p>
              Você receberá um link em seu e-mail para realizar o seu atendimento virtual, via Microsoft Teams, na data e hora seleciona.
            </p>
          </div>
        </div>
      </section>
    </div>
  </section>
</template>


<script>
import Field from "../../components/Field";
import api from "../../services/api";
import qs from "querystring";

export default {
  components: { Field },
  data() {
    return {
      Nome: "",
      Email: "",
      Telefone: "",
      DataAtendimento: "",
      MotivoAtendimento: "",
      ProcessoAtivo: "",
      Banco: "",
      Demitido: "",
      Sindicalizado: "",
      sindicalizadoPeriodo: "",
      Data: null,
      datas: [],
      horarios: [],
      buttonSubmited: false,
    };
  },

  async created() {
    document.getElementsByTagName("footer")[0].style.display = "none";
    document.getElementById("iframe-sz-chat").style.display = "none";
    await this.getDates();
    await this.getAreas();
  },

  methods: {
    async getDates() {
      const { data: data } = await api.get("online-scheduling/dates");
      this.datas = data.datas;
    },

    async getHours(event) {
      const { data: data } = await api.get(
        "online-scheduling/hours?date=" + event.target.value
      );
      this.horarios = data.hours;
    },

    async getAreas() {
      const { data: areas } = await api.get("contact/areas?online=true");
      this.areas = areas;
    },

    async submit() {
      this.buttonSubmited = true;

      try {
        // var form = document.getElementById("form-scheduling");
        var nome = document.querySelector('[name="Nome"]').value;
        var email = document.querySelector('[name="Email"]').value;
        var telefone = document.querySelector('[name="Telefone"]').value;
        var data = document.querySelector('[name="DataAtendimento"]').value;
        var motivo = document.querySelector('[name="MotivoAtendimento"]').value;
        var processoAtivo = document.querySelector(
          '[name="ProcessoAtivo"]'
        ).value;
        var banco = document.querySelector('[name="Banco"]').value;
        var demitido = document.querySelector('[name="Demitido"]').value;
        var sindicalizado = document.querySelector(
          '[name="Sindicalizado"]'
        ).value;
        var sindicalizadoPeriodo = document.querySelector(
          '[name="PeriodoSindicalizado"]'
        ).value;
        var area = document.querySelector('[name="Area"]').value;

        const requestBody = {
          Nome: nome,
          Email: email,
          Telefone: telefone,
          DataAtendimento: data,
          MotivoAtendimento: motivo,
          ProcessoAtivo: processoAtivo,
          Banco: banco,
          Demitido: demitido,
          Sindicalizado: sindicalizado,
          SindicalizadoPeriodo: sindicalizadoPeriodo,
          AreaContatoId: area,
          Origem: 'SEEB'
        };

        await api
          .post("online-scheduling", qs.stringify(requestBody))
          .then(() => {
            document.getElementById("form-scheduling").style.display = "none";
            document.getElementById("message-success").style.display = "block";
          })
          .catch(() => {
            alert(
              "Aconteceu um erro no envio de seu agendamento, Para mais dúvidas, ligue para (11) 3376-0100"
            );
          });
      } finally {
        this.buttonSubmited = false;
      }
    },
  },
};
</script>
